<template>
  <footer class="footer">
    <router-link class="logo" :to="{name: 'Home'}">
      <img src="../../assets/images/logo-cap.svg">
      <span>{{$store.getters.company.name}}</span>
    </router-link>
    <div class="copyright">All rights reserved by Capgemini. <br>Copyright © {{ new Date().getFullYear() }}</div>
    <ul class="footer-links">
      <li><router-link :to="{name: 'EngageForBusiness'}">Engage for Business</router-link></li>
      <li><router-link :to="{name: 'PrivacyPolicy'}">Privacy Policy</router-link></li>
      <li><router-link to="/company-select" v-if="showLogout && displayCompanySelect">Switch account</router-link></li>
      <li><a v-if="showLogout" @click="logout"><i class="icon-logout"></i></a></li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  },
  computed: {
    showLogout() {
      return this.$store.getters.company.hideNavBar && this.$store.getters.company.landingPageStatic
    },
    displayCompanySelect() {
      return this.$store.getters.userCompanies.length > 1 || this.$store.getters.publicCompanies.length
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('setToken', '')
      this.$store.dispatch('clearStorage')
      this.$router.push({name: 'Login'})
    }
  }
}
</script>

<style scoped>

</style>
